import { useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";

import axios from "@/configs/axios";
import { KB_SOURCE } from "@/util/constants";

export type Channel = {
  id: string;
  displayName: string;
  description: string;
  webUrl: string;
  driveId: string;
  folderId: string;
};

export type Team = {
  id: string;
  displayName: string;
  channels: Channel[];
};

export type Teams = Team[];

export const useGetTeams = (loginRequestForBackend: any) => {
  const { instance, accounts } = useMsal();

  return useQuery<Teams, Error>({
    queryKey: ["/getTeams", KB_SOURCE, accounts[0]?.homeAccountId],
    enabled: !!accounts[0],
    queryFn: async () => {
      const response = await instance.acquireTokenSilent({
        ...loginRequestForBackend,
        account: accounts[0],
      });
      const url = `${process.env.REACT_APP_SERVER_HOST}/teams-sync/teams`;
      const { data } = await axios.get(url, {
        headers: {
          oboToken: `${response.accessToken}`,
        },
      });

      return data.map((team: Team) => ({
        ...team,
        channels: [],
      }));
    },
  });
};
